var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOndasGotas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97pt",
    height: "88pt",
    viewBox: "0 0 97 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#fffffeff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "#9401c7ff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 33.49 15.41 C 37.39 19.97 40.41 25.35 42.13 31.11 C 43.63 35.60 41.04 40.97 36.50 42.40 C 30.57 44.37 23.83 39.32 24.61 33.01 C 25.87 26.46 29.71 20.77 33.49 15.41 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 10.36 19.17 C 14.55 19.18 18.42 20.89 22.39 21.99 C 21.57 23.78 20.82 25.61 19.80 27.29 C 16.27 26.56 12.22 25.86 9.75 22.96 C 9.88 21.69 10.09 20.42 10.36 19.17 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 55.04 20.77 C 57.41 20.15 59.84 18.67 62.33 19.57 C 65.80 20.67 69.30 22.04 73.02 21.74 C 77.78 21.90 82.00 19.08 86.76 19.15 C 86.95 20.68 87.52 22.24 87.14 23.78 C 79.34 28.82 69.37 28.52 60.86 25.59 C 56.40 26.40 52.05 28.06 47.41 27.78 C 46.59 25.75 45.74 23.73 44.91 21.71 C 48.30 21.68 51.80 21.96 55.04 20.77 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 9.38 37.04 C 9.97 35.69 10.78 34.39 12.09 33.65 C 14.37 34.25 16.81 34.86 18.66 36.38 C 19.76 38.25 20.20 40.42 20.87 42.46 C 16.92 41.27 11.49 41.24 9.38 37.04 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 57.85 34.78 C 62.35 32.92 66.46 36.88 70.99 36.67 C 75.56 37.26 79.78 35.35 84.07 34.15 C 86.91 33.20 88.86 37.76 86.14 39.10 C 80.62 42.58 73.67 43.32 67.33 42.21 C 64.28 41.70 61.22 39.68 58.11 41.01 C 54.22 42.41 50.09 42.84 45.97 42.66 C 46.76 40.88 47.48 39.06 48.52 37.41 C 51.59 36.39 54.78 35.81 57.85 34.78 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 10.94 54.00 C 8.39 52.55 9.96 49.66 12.05 48.66 C 16.05 49.58 19.80 51.71 24.00 51.66 C 27.66 51.94 31.12 50.61 34.56 49.56 C 37.19 48.55 39.82 49.95 42.34 50.63 C 45.04 51.56 47.91 51.65 50.73 51.85 C 49.84 53.83 48.92 55.79 48.03 57.77 C 44.22 57.49 40.61 56.21 36.90 55.48 C 33.85 55.73 31.03 57.16 27.99 57.47 C 22.16 58.08 15.95 57.15 10.94 54.00 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 51.76 65.04 C 53.27 58.80 56.62 53.10 60.72 48.22 C 64.35 53.37 67.89 58.82 69.37 65.03 C 70.58 70.15 66.21 75.68 60.94 75.60 C 55.37 76.25 50.51 70.40 51.76 65.04 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 70.60 51.86 C 75.60 51.96 80.25 50.16 84.96 48.80 C 86.97 49.28 87.86 50.90 87.32 52.88 C 83.63 56.59 77.95 57.16 72.99 57.68 C 72.20 55.74 71.39 53.80 70.60 51.86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 9.90 67.82 C 8.75 66.05 10.60 64.37 12.02 63.56 C 16.04 64.50 19.80 66.69 24.02 66.63 C 27.65 66.91 31.06 65.51 34.47 64.51 C 38.26 63.36 41.90 65.65 45.49 66.52 C 45.82 68.58 46.17 70.64 46.50 72.71 C 42.04 72.03 37.52 69.24 33.01 71.20 C 27.29 73.17 20.97 73.00 15.30 70.98 C 13.37 70.22 11.08 69.67 9.90 67.82 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9401c7",
    opacity: 1,
    d: " M 75.55 66.60 C 78.71 65.66 81.77 64.37 84.99 63.65 C 87.49 63.86 88.45 67.87 86.10 69.02 C 82.76 71.21 78.69 71.77 74.88 72.63 C 75.10 70.62 75.32 68.61 75.55 66.60 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndasGotas);
export default __webpack_public_path__ + "static/media/ondasGotas.3a5020609dd077a53b446147d5341e89.svg";
export { ForwardRef as ReactComponent };